import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const Logout: React.FC = () => {
  localStorage.removeItem("app_atkey");
  localStorage.removeItem("app_rtkey");
  const navigate = useNavigate();
  navigate("/login");

  useEffect(() => {
    const logoutUser = async () => {
      const accessToken = localStorage.getItem("app_atkey");
      const refreshToken = localStorage.getItem("app_rtkey");

      if (!accessToken || !refreshToken) {
        toast.error("توکنی برای خروج یافت نشد");
        navigate("/login");
        return;
      }
      try {
        const res = await axios.post(
          `https://api.makimal.ir/logout?app_atkey=${accessToken}&app_rtkey=${refreshToken}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            timeout: 10000, // 10 ثانیه تایم‌اوت
          }
        );
        toast.success("با موفقیت خارج شدید");
        // localStorage.removeItem("app_atkey");
        // localStorage.removeItem("app_rtkey");
        // navigate("/login");
      } catch (error) {
        if (axios.isAxiosError(error)) {
          if (error?.response) {
            toast.error(`خطا: "مشکلی پیش آمد"}`);
          } else if (error.request) {
            console.error("پاسخی از سرور دریافت نشد:", error.request);
          }
        } else {
          console.error("خطای ناشناخته:", error);
          toast.error("خطای ناشناخته، لطفاً بعداً تلاش کنید.");
        }
      }
    };
    logoutUser();
  }, [navigate]);

  return (
    <>
      <ToastContainer
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
        position="top-center" // جایگاه نوتیفیکیشن را مشخص کنید
        autoClose={3000} // مدت زمان بسته شدن اتوماتیک
      />
    </>
  );
};

export default Logout;
